import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { API_URL } from '../../api-config';

const SpreadManager = () => {
  const [spreadBid, setSpreadBid] = useState(0.1);
  const [spreadAsk, setSpreadAsk] = useState(0.2);

  const handleSubmit = async () => {
    if (spreadBid < 0 || spreadBid > 1 || spreadAsk < 0 || spreadAsk > 1) {
      toast.error("Los valores deben estar entre 0 y 1", { position: toast.POSITION.TOP_RIGHT });
      return;
    }

    try {
      const token = localStorage.getItem("token");

      await axios.post(
        `${API_URL}/trading-api/sistema/spread?spread_bid=${spreadBid}&spread_ask=${spreadAsk}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      toast.success("Spread guardado exitosamente", { position: toast.POSITION.TOP_RIGHT });
    } catch (error) {
      console.error(error);
      toast.error("Error al guardar el spread", { position: toast.POSITION.TOP_RIGHT });
    }
  };

  return (
    <div className="p-4 text-white bg-gray-800 rounded-xl max-w-md mx-auto mt-10 shadow-lg">
      <h2 className="text-xl font-semibold mb-4">Configuración de Spread</h2>

      <div className="mb-3">
        <label className="block mb-1">Spread Bid (0 - 1)</label>
        <input
          type="number"
          step="0.01"
          value={spreadBid}
          onChange={(e) => setSpreadBid(parseFloat(e.target.value))}
          className="w-full px-3 py-2 rounded text-black"
        />
      </div>

      <div className="mb-3">
        <label className="block mb-1">Spread Ask (0 - 1)</label>
        <input
          type="number"
          step="0.01"
          value={spreadAsk}
          onChange={(e) => setSpreadAsk(parseFloat(e.target.value))}
          className="w-full px-3 py-2 rounded text-black"
        />
      </div>

      <button
        onClick={handleSubmit}
        className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
      >
        Guardar Spread
      </button>
    </div>
  );
};

export default SpreadManager;
